export default __webpack_public_path__ + "media/components/Pages/Abitur/Top-6c9783e06bbdf64e27357a87a84bf4a0.jpg";